export default class Producers {
  constructor() {
    this.producerEl = document.querySelector('.js-producer');

    if (this.producerEl) {
      this.getInfo();
    }
  }

  getInfo() {
    const producerHandle = this.producerEl.dataset.producerHandle;
    const producerElement = this.producerEl;
    if (producerHandle !== '') {
      fetch(`https://coavacoffee.com/producer/${producerHandle}.json`)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          producerElement.innerHTML = `
            <div class="image_w_text_card image_w_text_card--alternate">
              <div class="image_w_text_card-images">
                <img src="${data.image}" alt="" />
              </div>
              <div class="image_w_text_card-card">
                <div class="text_card text_card--shadow has-button">
                  <h3 class="text_card-title">Produced By</h3>
                  <div class="text_card-content">
                    <h2>${data.title}</h2>
                    <p>${data.summary}</p>
                  </div>
                  <a class="button text_card-link" href="${data.url}" title="">Read More</a>
                </div>
              </div>
            </div>
          `;
        });
    }
  }
}
